module.exports = __webpack_public_path__ + "static/media/jl.0cb6724e.png";


//////////////////
// WEBPACK FOOTER
// ./src/safetyTrainingCourses/record/images/jl.png
// module id = 1548
// module chunks = 0